import React from 'react';

import { Tooltip } from '@/components/Tooltip';

export interface QueryTypeProps {
  value: 'graph' | 'table' | 'table-tree';
  editable: boolean;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export function QueryType({ value, editable, onChange }: QueryTypeProps) {
  const tooltipContent = (
    <>
      <strong>Graph:</strong> visualize results in a graph
      <br />
      <strong>Table:</strong> display the &quot;root&quot; node of each result
      in a table
    </>
  );

  if (editable) {
    const displayValue = value === 'table-tree' ? 'table' : value;

    return (
      <div className="flex items-center gap-2">
        <Tooltip title={tooltipContent}>
          <label
            htmlFor="query-type"
            className="text-chariot-text-secondary text-sm"
          >
            Type:
          </label>
        </Tooltip>
        <select
          id="query-type"
          value={displayValue}
          onChange={onChange}
          className="bg-chariot-background-secondary text-chariot-text-primary border-chariot-stroke focus:border-chariot-brand-primary rounded-md border px-2 py-1 text-sm outline-none"
          data-testid="query-header-type-select"
        >
          <option value="graph">Graph</option>
          <option value="table">Table</option>
        </select>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Tooltip title={tooltipContent}>
        <span className="text-chariot-text-secondary text-sm">Type:</span>
      </Tooltip>
      <span className="text-chariot-text-primary text-sm">
        {value === 'graph' ? 'Graph' : 'Table'}
      </span>
    </div>
  );
}
